/**
 * In type script there is no explicit class for any type but sometimes such serialization is required.
 * This simple class will allow direct serialization and deserialization. No transformations will be applied 
 * for properties which specify it as a type argument.
 * 
 * @type {Any}
 */
export class Any
{
    
}
